import { Component, OnInit, Input } from '@angular/core';
import { IFundraiser } from '../../../fundraiser/models/fundraiser.model';
import { FundraiserService, UtilService } from '../../../shared/services';

@Component({
  selector: 'app-updates-tab',
  templateUrl: './updates-tab.component.html',
  styleUrls: ['./updates-tab.component.scss']
})
export class UpdatesTabComponent implements OnInit {

  @Input() public fundraiser: IFundraiser;
  @Input() public updates;
  @Input() public isDonated;
  @Input() public sharedCounts;
  @Input() public isFundraiserEnded;
  @Input() public loadTab;
  count = 1;

  constructor(
    private fundraiserService: FundraiserService,
    private utilService: UtilService
  ) { }

  ngOnInit() {
    // this.getFundraiserUpdates();
  }

  getLength(update) {
    return update && update.data && update.data.length ? update.data.length : 0;
  }
  /**Get update listner */
  viewUpdateEvent = (data) => {
    if (data) {
      this.count++;
      this.getFundraiserUpdates();
    }
  }
  /**Get fundraiser updates */
  getFundraiserUpdates() {
    // this.count++;
    const qParam = `?with=owner.avtar;comments&limit=${this.count}&orderBy=creation_time&sortedBy=desc`;
    this.fundraiserService.getFundraiserUpdates(this.fundraiser.custom_tag, qParam).subscribe((res: any) => {
      const pre_update_ids: any[] = this.updates?.data?.map(item => { if (item?.id) { return item.id; } });
      res?.data?.data?.forEach((item, i) => {
        if (pre_update_ids.includes(item?.id)) {
          res.data.data[i] = this.updates.data[i];
        }
      });
      this.updates = res.data;
      res?.data?.data?.forEach((item, i) => {
        res.data.data[i].owner['creation_time'] = res.data.data[i].creation_time;
        if (!this.updates.data[i].user_liked) {
          this.updates.data[i].user_liked = { 'status': 0 };
        }
        if (!pre_update_ids.includes(item?.id)) {
          const qparam = `/${item?.id}/comments?limit=5`;
          this.fundraiserService.getFundraiserUpdates(this.fundraiser.custom_tag, qparam).subscribe({
            next: (res: any) => {
              this.updates.data[i]['comments'] = res?.data;
              this.updates.data[i]['comments'].placeholder = 'Write something to cheer ' + this.fundraiser.campaigner.fname;
            }
          });
        }
      });
      this.updates.data['facebook'] = {
        label: 'Spread the word',
        count: this.sharedCounts.fb,
        campaign_url: this.utilService.domain_details.full_url
      };
    });
  }
}
